import { useMemo, useEffect } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'

const ImageThumbnail = styled.div`
  width: ${rem(80)};
  height: ${rem(80)};
  border-radius: ${rem(8)};
  overflow: hidden;
  background-color: ${props => props.theme.palette.neutral.default.six};

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`

interface Props {
  file: File
}

function ImageThumbnailPreview({ file }: Props) {
  const imageUrl = useMemo(() => {
    return URL.createObjectURL(file)
  }, [file])

  useEffect(() => {
    return () => {
      URL.revokeObjectURL(imageUrl)
    }
  }, [imageUrl])

  return (
    <ImageThumbnail>
      <img src={imageUrl} alt={file.name} />
    </ImageThumbnail>
  )
}

export default ImageThumbnailPreview
